import React, { useEffect, useState } from "react";
import Sidebar from "../../Shared/Sidebar";
import LessSidebar from "../../Shared/LessSidebar";
import Preloader from "../../Shared/Preloader/Preloader";
import Navbar from "../../Shared/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  Button,
  Modal,
  Form,
  Col,
  Row,
  Table,
} from "@themesberg/react-bootstrap";
import { currentUser } from "../../../authentication/auth";
import {
  faPaperPlane,
  faPlus,
  faPlusCircle,
  faSave,
  faWarehouse,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Category from "./components/Category";
import Supplier from "./components/Fournisseur";
import FirebaseNotif from "../../Shared/FirebaseNotif/FirebaseNotif";
import StockService from "../../services/StockService";
import AddSupplierModal from "./components/Modals/Supplier";
import AddPurchaseModal from "./components/Modals/Invoice";
const LaboStock = () => {
  const [showAddProduct, setShowAddProduct] = useState(false);
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [showAddSupplier, setShowAddSupplier] = useState(false);
  const [showAddPurchase, setShowAddPurchase] = useState(false);
  const [products, setProducts] = useState([]);
  const [update, setUpdate] = useState(0);

  const handleClose = () => {
    setShowAddProduct(false);
    setShowAddCategory(false);
    setShowAddSupplier(false);
    setShowAddPurchase(false);
  };
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    if (currentUser() == null) {
      navigate("/login");
    } else {
      setUser(currentUser());
    }
    getCategories();
    getSuppliers();
    getProducts();
  }, [update]);
  const [categories, setCategories] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const getCategories = async () => {
    try {
      const res = await StockService.getCategories(`?is_parent=true`);
      if (res.status === 200) {
        setCategories(res.data.data.list);
      }
    } catch (e) {
      // console.log(e);
    }
  };
  const getSuppliers = async () => {
    try {
      const res = await StockService.getSuppliers(``);
      if (res.status === 200) {
        setSuppliers(res.data.data.list);
      }
    } catch (e) {}
  };
  const getProducts = async () => {
    try {
      const res = await StockService.getProducts(``);
      if (res.status === 200) {
        setProducts(res.data.data.list);
      }
    } catch (err) {
      NotificationManager.error(err?.response?.data?.message, "Stock");
    }
  };
  const [name, setName] = useState("");
  const [uri, setUri] = useState(null);
  const [category_id, setCategoryId] = useState(null);
  const addProduct = () => {};
  const addCategory = async (e) => {
    e.preventDefault();
    try {
      const res = await StockService.addCategory({
        name,
        uri,
        category_id,
      });
      if (res.status === 200) {
        NotificationManager.success(res.data.message, "Stock");
        handleClose();
        getCategories();
      }
    } catch (e) {
      NotificationManager.error("error", "Stock");
    }
  };

  const [hideSidebar, setHideSidebar] = useState(
    JSON.parse(localStorage.getItem("sidebar-state"))
  );
  return (
    <>
      <Preloader />
      <div className={`content`}>
        {hideSidebar ? (
          <LessSidebar
            user={user}
            expand={() => {
              setHideSidebar(false);
              localStorage.setItem("sidebar-state", false);
            }}
          />
        ) : (
          <Sidebar
            user={user}
            expand={() => {
              setHideSidebar(true);
              localStorage.setItem("sidebar-state", true);
            }}
          />
        )}
      </div>
      {/* <FirebaseNotif /> */}
      <main className={`content ${hideSidebar ? "mleft-0" : ""}`}>
        <Navbar user={user} pageName={"Gestion du stock"} icon={faWarehouse} />
        <hr />
        <div>
          <div className="text-end mb-3"></div>
        </div>

        <div>
          <div className="d-flex justify-content-end">
            <Button
              variant={"main"}
              size="sm"
              onClick={() => setShowAddCategory(true)}
            >
              <FontAwesomeIcon icon={faPlusCircle} /> Ajouter categorie{" "}
            </Button>
            {/* <Button variant={"main"} onClick={() => setShowAddProduct(true)}>
              <FontAwesomeIcon icon={faPlusCircle} /> Ajouter article{" "}
            </Button> */}
          </div>

          <div className="mt-2">
            <Row>
              <Col md={12}> Mes categories / </Col>
              {categories.map((c) => (
                <Col md={12} lg={3}>
                  <Category category={c} />
                </Col>
              ))}
            </Row>
            <hr />
            <div>
              <div className="d-flex justify-content-end">
                <Button
                  size="sm"
                  variant={"main"}
                  onClick={() => setShowAddPurchase(true)}
                >
                  <FontAwesomeIcon icon={faPlusCircle} /> Nouveau achat{" "}
                </Button>
              </div>
              <h5>Derniers achats</h5>
              <Table
                responsive
                hover={true}
                className="align-items-center table-flush table-bordered"
              >
                <thead className="thead-light">
                  <tr>
                    <td>Numero</td>
                    <td>Nom</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>test</td>
                    <td>test</td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <hr />
            <div>
              <div className="d-flex justify-content-end">
                <Button
                  size="sm"
                  variant={"main"}
                  onClick={() => {
                    setShowAddSupplier(true);
                    console.log("Show declanched ...");
                    console.log(showAddSupplier);
                    setUpdate((prev) => prev + 1);
                  }}
                >
                  <FontAwesomeIcon icon={faPlusCircle} /> Nouveau fournisseur{" "}
                </Button>
              </div>
              <h5>Liste des frournisseurs</h5>
              <Row>
                {suppliers.map((s) => (
                  <Col md={12} lg={3}>
                    <Supplier data={s} />
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>

        <NotificationContainer />
      </main>
      <Modal
        as={Modal.Dialog}
        centered
        show={showAddCategory}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header>
          <Modal.Title className="h6">
            <FontAwesomeIcon icon={faPlus} /> Ajouter nouvelle catégorie
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <div className={""}>
            <Form onSubmit={addCategory}>
              <Form.Group className="mb-2">
                <Form.Label>Nomination </Form.Label>
                <Form.Control
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                ></Form.Control>
              </Form.Group>

              {/* <Form.Group className="mb-2">
                <Form.Label>Categorie article</Form.Label>
                <select className="form-control">
                  <option>Categorie 1</option>
                  <option>Categorie 1</option>
                </select>
              </Form.Group> */}
              <Form.Group className="mb-2">
                <Form.Label>Image </Form.Label>
                <Form.Control type="file"></Form.Control>
              </Form.Group>

              <Form.Group className="d-flex justify-content-end">
                <Button type="submit" variant={"main"}>
                  <FontAwesomeIcon icon={faSave} /> Sauvegarder{" "}
                </Button>
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        as={Modal.Dialog}
        centered
        show={showAddProduct}
        onHide={handleClose}
        size={"lg"}
      >
        <Modal.Header>
          <Modal.Title className="h6">
            <FontAwesomeIcon icon={faPlus} /> Ajouter catégorie
          </Modal.Title>
          <Button variant="close" aria-label="Close" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <div className={""}>
            <Form>
              <Form.Group className="mb-2">
                <Form.Label>Nom </Form.Label>
                <Form.Control></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Nom article</Form.Label>
                <Form.Control></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Categorie article</Form.Label>
                <select className="form-control">
                  <option>Categorie 1</option>
                  <option>Categorie 1</option>
                </select>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Description article</Form.Label>
                <Form.Control as="textarea"></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Qunatite article</Form.Label>
                <Form.Control type="number"></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Unite article</Form.Label>
                <select className="form-control">
                  <option>Unite 1</option>
                </select>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Prix article</Form.Label>
                <Form.Control type="number"></Form.Control>
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Commentaire article</Form.Label>
                <Form.Control></Form.Control>
              </Form.Group>

              <Form.Group className="d-flex justify-content-end">
                <Button type="submit" variant={"main"}>
                  <FontAwesomeIcon icon={faSave} /> Sauvegarder{" "}
                </Button>
              </Form.Group>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      <AddSupplierModal
        refreshData={() => {
          getSuppliers();
        }}
        show={showAddSupplier}
        handleClose={() => handleClose()}
        setShow={(value) => setShowAddSupplier(value)}
      />
      <AddPurchaseModal
        show={showAddPurchase}
        handleClose={() => handleClose()}
        setShow={(value) => setShowAddPurchase(value)}
        productsListe={products}
        suppliersListe={suppliers}
      />
    </>
  );
};

export default LaboStock;
